export enum GiftCardErrorEnum {
  USER_NOT_CREATED = 'Unable to create user',
  NOT_ACTIVE = 'Gift card inactive',
  NOT_FOUND = 'Gift card not found',
  INSUFFICIENT_BALANCE = 'Insufficient balance',
  EXPIRED = 'Gift card expired',
  REDEMPTION_FAILED = 'Gift card redemption failed',
  TOPUP_FAILED = 'Gift card topup failed',
  INSUFFICIENT_PERMISSIONS = 'Cannot be redeemed at this merchant',
  NOT_PUBLIC = 'Gift card not for public use.',
  CANNOT_BE_REGISTERED = "Gift Card cannot be registered"
}
